<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <el-tabs v-model="active" type="card">
        <el-tab-pane name="bidding">
          <template #label>
            <span><i class="el-icon-coin"></i> 线上申报</span>
          </template>
          <template>
            <el-alert center :closable="false" type="info"  effect="dark" style="background-color: #9cccdd; margin: 5px 0;">
              <!-- 请先进行标书下载, 完成后再进行标书上传。 -->
              <template slot="title">
                <div style="font-size: 16px; font-family: '黑体'; margin: 8px 0">{{ form.title }}</div>
              </template>
            </el-alert>
            <el-alert title="" type="info" :closable="false" style="background-color: #fff; width: 980px;"></el-alert>
            <el-alert type="info" :closable="false" style="margin-bottom: 5px; padding: 15px; width: 980px;">
              <p style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 5px;">{{ `1、项目名称: ` + form.projectName }}</p>
              <p style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 5px;">{{ `2、项目编号: ` + form.projectCode }}</p>
              <p style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 5px;">3、申报材料模板下载: <a :href="`http://www.shgpo.com/member/readflie.jspx?filePath=`+form.link" target="_blank" style="color: #1890ff; cursor: pointer; font-weight: 500;">&ensp;点我下载&ensp;<i class="el-icon-download" style="font-size: 14px;"></i></a></p>
              <p style="font-size: 14px; font-family: '黑体'; color: #333333;">4、申报截止日期：{{toDateString(form.expiryDate, 'yyyy年MM月dd日HH时')}}</p>
            </el-alert>
            <el-alert title="" type="info" :closable="false" style="background-color: #fff; width: 980px;"></el-alert>
            <!-- <template v-if="form.companyType == '3'">

              <el-alert type="info" :closable="false" style="margin-bottom: 5px; padding: 15px; width: 980px;">
                <p style="font-size: 16px; font-weight: 500; font-family: '黑体'; color: #666666; margin-bottom: 5px;">
                  投标文件上传功能将在报名结束后开放，请各投标企业知悉。
                </p>
              </el-alert>
            </template> -->
            <template v-if="form.companyType == '3'">
                <el-divider content-position="left">步骤一：选择申报目录编号</el-divider>
                <el-button plain style="width: 100%; margin: 15px 0 30px;" size="small" :disabled="form.disabled" @click="dialogVisible = true">
                  <i class="el-icon-plus" /> 点我选择并添加申报项目
                </el-button>

                <el-divider content-position="left">步骤二：上传申报文件</el-divider>
                <el-alert title="" type="info" :closable="false" style="margin-top: 25px; margin-bottom: 5px; padding: 15px; width: 980px;">
                <p style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 5px;">
                  1、申报截止时间：{{toDateString(form.expiryDate, 'yyyy年MM月dd日HH时')}}；
                  <!-- 四、投标截止及开标时间：1、投标截止时间：2022-08-23 15:00，迟到或不符合规定的投标文件恕不接受。2、开标时间：2022-08-23 15:00。 -->
                </p>
                <p style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 5px;">
                  2、申报文件要求：按公告要求制作申报文件，并保存为PDF文件（大小不超过200M）。
                </p>
                </el-alert>
                <el-table :data="resultList" border style="width: 100%; margin-top: 15px;" size="mini" @cell-mouse-leave="showClickIcon=false">
                  <el-table-column fixed="left" prop="id" label="目录编号" width="70" align='center'></el-table-column>
                  <el-table-column prop="drugName" label="通用名" width="280" align='center'></el-table-column>
                  <el-table-column prop="categoryName" label="工艺分类" width="90" align='center' :show-overflow-tooltip='true'></el-table-column>
                  <el-table-column prop="dosageSpecific" label="抗原含量和剂量" width="110" align='center' :show-overflow-tooltip='true'></el-table-column>
                  <el-table-column prop="packageMethod" label="包装" width="100" align='center'></el-table-column>
                  <el-table-column prop="packageMethod" label="上传状态" width="170" align='center'>
                    <template #default="scope">
                      <template v-if="!!scope.row.attachsPath">
                        <a :href="`http://www.shgpo.com/member/readflie.jspx?filePath=`+scope.row.attachsPath" target="_blank" style="color: #1890ff; cursor: pointer; font-weight: 500;">{{scope.row.attachsName}}&ensp;<i class="el-icon-download" style="font-size: 14px;"></i></a>
                        <br>
                        上传时间{{toDateString(scope.row.uploadOn.time, 'yyyy/MM/dd HH:mm')}}
                      </template>
                    </template>
                  </el-table-column>

                  <el-table-column fixed="right" label="操作" width="170" align='center'>
                    <template #default="scope">
                      <el-tag @click="preUploadFile(scope.row)" size="medium" disable-transitions style="cursor: pointer;">文件上传</el-tag>
                      <el-tag @click="removeTenders(scope.row)" type="danger" size="medium" disable-transitions style="cursor: pointer; width: 75px;" effect="plain">项目移除</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
            </template>
            <template v-if="form.companyType == '4'">
              <el-alert title="" type="info" :closable="false" style="margin-bottom: 5px; padding: 15px; width: 980px;">
                <p style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 5px;">
                  1、投标截止时间：{{form.expirySubmitOn}}，迟到或不符合规定的投标文件恕不接受。
                </p>
                <p style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 5px;">
                  2、投标文件要求：按招标文件要求制作投标文件，并保存为PDF文件（大小不超过200M）。
                </p>
                <p>&emsp;</p>
                <el-form @submit.native.prevent style="text-align: left; " label-position="right" label-width="100px" status-icon key="qyzzUpload" :model="form" ref="qyzzUpload">
                  <el-form-item label="投标文件上传" style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 0px;" prop="yyzzImg">
                    <el-upload
                      class="upload-left"
                      :action="uploadImgUrl"
                      :on-preview="handlePreview"
                      :before-remove="beforeRemove"
                      :on-remove="handleRemoveyyzzImg"
                      :multiple="false"
                      :limit="1"
                      :on-exceed="handleExceed"
                      :before-upload="beforeFileUpload"
                      :on-success="handleSuccessyyzzImg"
                      :on-error="handleError"
                      :file-list="fileList"
                      :disabled="form.disabled"
                      >
                      <el-button :loading="submitButtonLoading" size="small" type="primary" :disabled="form.disabled">点我上传 (限PDF文件)</el-button>
                    </el-upload>
                    <el-button :loading="submitButtonLoading" type="primary" size="small" style="margin: 20px  0 0 0;" @click="submitForm" :disabled="form.disabled">&ensp;提&ensp;&ensp;交&ensp;</el-button>
                    <template v-if="form.disabled">
                      <el-button :loading="submitButtonLoading" type="primary" size="small" style="margin: 20px 0 0 0;" @click="form.disabled = false;" :disabled="!form.disabled">&ensp;重新上传&ensp;</el-button>
                    </template>
                  </el-form-item>
                </el-form>
              </el-alert>
            </template>
            <el-alert title="" type="info" :closable="false" style="background-color: #fff; width: 980px;">
              <p style="font-size: 14px; font-family: '黑体'; color: #333333; margin-bottom: 5px;">
                如您有任何问题，请及时与我中心联系<br>
                联系电话：021-62051086<br>
                电子邮箱：services@shgpo.com<br>
              </p>
            </el-alert>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
  <!-- 选择疫苗项目并确认 -->
  <el-dialog title="选择申报项目" :visible.sync="dialogVisible" width="1200px" top="145px">
    <template>
      <div style="width: 100%; height: 95px;">
        <p style="float: left; width: 630px; height: 95px;">&emsp;</p>
        <p style=" margin: 0 0 20px; float: left;">
          操作说明：<br>
          1、在左侧“目录列表”中选择拟申报项目，点击“添加”按钮，添加至贵企业的“申报<br>项目”中，以便进行后续对应的申报文件上传等操作。<br>
          2、在右侧“申报项目”中选择某一目录编号，点击“移除”按钮，可将该项目自贵企业<br>的“申报项目”中移除。
        </p>
      </div>
      <div class="el-transfer-div" style="text-align: center">
        <el-transfer
          style="text-align: left; display: inline-block; height: 315px;"
          v-model="chosenList"
          filterable
          :left-default-checked="[]"
          :right-default-checked="[]"
          filter-placeholder="请输入申报的项目编号或者疫苗名称搜索"
          :titles="['选择拟申报的项目编号', '申报项目']"
          :button-texts="['移除', '添加 ']"
          :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
          :data="productList">
          <span slot-scope="{ option }" style="font-size: 11px;">{{ option.label }}</span>
        </el-transfer>
        <el-button plain style="width: 100%; font-size: 14px; font-weight: 500;" size="small" type="primary" @click="submitTenders" :disabled="0 == chosenList.length">
          <i class="el-icon-circle-check" style="font-size: 16px;" /> &ensp;确认申报项目
        </el-button>
      </div>
    </template>
  </el-dialog>
  <!-- 上传疫苗项目投标文件PDF -->
  <el-dialog title="文件上传" :visible.sync="dialogUploadVisible" width="650px">
    <el-form :model="tenders" label-width="150px" :inline="true">
      <el-row type="flex">
      <el-form-item label="目录编号" style="margin-bottom: 0;">
        <el-tag effect="plain" style="text-align: left; font-size: 14px; border: 0;">{{ tenders.batchId }}</el-tag>
      </el-form-item>
      </el-row>
      <el-row type="flex">
      <el-form-item label="通用名" style="margin-bottom: 0;">
        <el-tag effect="plain" style="text-align: left; font-size: 14px; border: 0;">{{ tenders.drugName }}</el-tag>
      </el-form-item>
      </el-row>
      <el-row type="flex">
      <el-form-item label="工艺分类" style="margin-bottom: 0;">
        <el-tag effect="plain" style="text-align: left; font-size: 14px; border: 0;">{{ tenders.categoryName }}</el-tag>
      </el-form-item>
      </el-row>
      <el-row type="flex">
      <el-form-item label="抗原含量和剂量" style="margin-bottom: 0;">
        <el-tag effect="plain" style="text-align: left; font-size: 14px; border: 0;">{{ tenders.dosageSpecific }}</el-tag>
      </el-form-item>
      </el-row>
      <el-row type="flex">
      <el-form-item label="包装">
        <el-tag effect="plain" style="text-align: left; font-size: 14px; border: 0;">{{ tenders.packageMethod }}</el-tag>
      </el-form-item>
      </el-row>
      <el-row type="flex">
        <el-form-item label="文件上传" prop="attachsName">
          <el-upload
            class="upload-left"
            :action="uploadImgUrl"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-remove="handleRemoveyyzzImg"
            :multiple="false"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeFileUpload"
            :on-success="handleSuccessTenders"
            :on-error="handleError"
            :file-list="fileList"
            >
            <el-button :loading="submitButtonLoading" size="small" type="primary">点我上传 (限PDF文件)</el-button>
          </el-upload>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" icon="el-icon-check" size="small" :loading="submitButtonLoading" @click="submitTendersFile()" :disabled="!tenders.attachsPath">&emsp;提&emsp;交&emsp;</el-button>
      <el-button icon="el-icon-close" size="small" @click="dialogUploadVisible = false">&emsp;取&emsp;消&emsp;</el-button>
    </span>
  </el-dialog>
  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'bidding-online',
    data(){
      return {
        active: 'bidding',
        height: 0,
        submitButtonLoading: false,
        dialogVisible: false,
        dialogUploadVisible: false,
        uploadImgUrl: '',
        tenders: { id: '', batchId: '', drugName: '', categoryName: '', dosageSpecific: '', packageMethod: '', drugDosage: '', attachsName: '', attachsPath: '' },
        fileList: [],
        productList: [],
        chosenList: [],
        resultList: [],
        form: {
          id: '', attachsName: '', attachsPath: '', disabled: false,
          companyType: 0, title: '', projectName: '', projectCode: '', expirySubmitOn: '', link: '', expiryDate: new Date()
        },
        businessConfig: {}
      };
    },
    mounted(){
      // sessionStorage['/biddingonline'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight -350}
    },
    created() {
      this.uploadImgUrl = process.env.VUE_APP_API_URL + 'member/o_upload_image2.jspx';
      this.offerUploadUrl = process.env.VUE_APP_API_URL + 'member/o_upload_offer.jspx';
      this.initView();
    },
    methods: {
      initView(){
        setTimeout(() => {
          const self = this
          self.submitButtonLoading = true;
          //这里需要调整，疫苗配送企业的调表失效时间与生产企业不一致，暂时没有考虑配送
          self.getBusinessConfig({ stype: 'VACCINE' }).then(res => {
            self.handleBusinessConfig(res);
            return self.getUserAttachments({});
          }).then(res => {
            self.handleUserAttachments(res);
            return self.getVaccineProduct();
          }).then(res => {
            self.handleVaccineProduct(res);
          }).catch(err => {
            console.info(err);
          })
        }, 200)
      },
      getBusinessConfig: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.getBusinessConfig(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(JSON.parse(res.data.data));
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleBusinessConfig: function(res){
        this.businessConfig = { ...res[0] }
        //console.log(`this.businessConfig =>`, this.businessConfig)
        const { step1, step2, step3, step4, noticeLink, expiryDate } = { ...res[0] }
        this.form.title = step1;
        this.form.projectName = step2;
        this.form.projectCode = step3;
        this.form.expirySubmitOn = step4;
        this.form.link = noticeLink;
        this.form.expiryDate = new Date(expiryDate.time);
      },
      getUserAttachments(param){
        return new Promise(resolve => {
          this.$api.memberApi.getUserAttachmemts(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(JSON.parse(res.data.data))
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        });
      },
      handleUserAttachments(data){
        const { companyType, name, path } = {...data[0] }
        if(companyType){
          this.form.companyType = companyType;
        }
        if(name && path){
          this.form.attachsName = name;
          this.form.attachsPath = path;
          this.fileList = [];
          this.fileList.push({ name: name, url: path, response: {data: path}});
          this.form.disabled = true;
        }
      },
      getVaccineProduct: function(){
        return new Promise(resolve => {
          this.$api.memberApi.getVaccineProduct({stype: 'VACCINE'}).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(JSON.parse(res.data.data))
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        });
      },
      handleVaccineProduct: function(data){
        this.resultList = []
        this.productList = []
        data.forEach((obj, idx) => {
          if(0 === obj.resultId){
            const { id, drugName, categoryName, dosageSpecific, packageMethod } = {...obj}
            this.productList.push({key: obj.id, label: `${id}->${drugName}-${categoryName}-${dosageSpecific}(${packageMethod})`})
          }else{
            this.resultList.push(obj)
          }
        })
      },
      preUploadFile(data){
        const { id, drugName, categoryName, dosageSpecific, packageMethod, drugDosage, resultId } = {...data};
        this.tenders.id = resultId;
        this.tenders.batchId = id;
        this.tenders.drugName = drugName;
        this.tenders.categoryName = categoryName;
        this.tenders.dosageSpecific = dosageSpecific;
        this.tenders.packageMethod = packageMethod;
        this.tenders.attachsName = '';
        this.tenders.attachsPath = '';
        this.fileList = [];
        this.dialogUploadVisible = true;
      },
      submitForm() {
        let {id, attachsName, attachsPath } = {...this.form};
        if(!attachsName || !attachsPath){
          this.$message({ message: '请上传标书后再提交！', offset: 200, type: 'error' });
          return ;
        }
        let objson = {};
        Object.assign(objson, this.form, { fileName: '疫苗集团采购项目线上招投标' });
        this.submitButtonLoading = true;
        this.form.disabled = true;
        this.$api.memberApi.submitBiddingform(objson).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.$message({ message: '标书文件提交成功！', offset: 200, type: 'success' });
              this.getUserAttachmemts();
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
            this.form.disabled = false;
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      vaccineProductList(){
        this.getVaccineProduct({}).then(res => {
          this.handleVaccineProduct(res);
        })
      },
      submitTenders() {
        if(null == this.chosenList || 0 == this.chosenList.length){
          this.$message({ message: '请先选择需要申报的项目！', offset: 200, type: 'warning' });
          return false;
        }
        this.$confirm(`您已选择 ${this.chosenList.length}个项目，是否确认将申报上述项目？`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '返回检查',
          type: 'info'
        }).then(() => {
          this.submitButtonLoading = true;
          let objson = {};
          Object.assign(objson, { ids: this.chosenList.join(',') }, { stype: 'VACCINE' });
          this.$api.memberApi.submitTenders(objson).then(response => {
            this.submitButtonLoading = false;
            if(response.status === 200){
              if(response.data.code === 200){
                this.chosenList.length = [];
                this.dialogVisible = false;
                this.$message({ message: '保存成功！', offset: 200, type: 'success' });
                this.vaccineProductList();
              }else{
                this.$message({ message: response.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        }).catch(() => {

        });
      },
      submitTendersFile(){
        const { id, batchId, attachsName, attachsPath } = { ...this.tenders }
        if(id && attachsName && attachsPath){
          let objson = {};
          Object.assign(objson, { id: id, attachsName: attachsName, attachsPath: attachsPath, stype: 'VACCINE' });
          this.$api.memberApi.submitTendersFile(objson).then(response => {
            this.submitButtonLoading = false;
            if(response.status === 200){
              if(response.data.code === 200){
                this.chosenList.length = [];
                this.dialogUploadVisible = false;
                this.$message({ message: `项目${batchId}文件上传成功！`, offset: 200, type: 'success' });
                this.vaccineProductList();
              }else{
                this.$message({ message: response.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        }else{
          this.$message({ message: '请刷新后重试!', offset: 200, type: 'error' });
        }
      },
      removeTenders(data){
        this.$confirm('您确定要删除项目'+ data.id+' 吗？<br>如您已上传项目申报文件，移除项目则文件将同步删除。<br>(您可以重复步骤一继续添加申报项目)', '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确认移除',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.submitButtonLoading = true;
          let objson = {};
          Object.assign(objson, { id: data.resultId, stype: 'VACCINE' });
          this.$api.memberApi.removeTenders(objson).then(response => {
            this.submitButtonLoading = false;
            if(response.status === 200){
              if(response.data.code === 200){
                this.$message({ message: `项目 ${data.id} 移除成功！`, offset: 200, type: 'success' });
                this.vaccineProductList();
              }else{
                this.$message({ message: response.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        }).catch(() => {

        });
      },
      beforeRemove(file, fileList) {
        console.log(file);
        if(file.status !== 'ready')
          return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleRemoveyyzzImg(file, fileList) {
        this.form.attachsName = '';
        this.form.attachsPath = '';
        this.fileList = fileList.slice(0,0);
      },
      handleSuccessyyzzImg(response, file, fileList) {
        if (response.code === 200) {
          this.form.attachsName = file.name;
          this.form.attachsPath = response.data;
          this.fileList = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileList = fileList.slice(0,0);
        }
      },
      handleSuccessTenders(response, file, fileList) {
        if (response.code === 200) {
          this.tenders.attachsName = file.name;
          this.tenders.attachsPath = response.data;
          this.fileList = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileList = fileList.slice(0,0);
        }
      },
      handleError(response, file, fileList) {
        this.$message.error(`上传失败，请稍后再试`);
      },
      handlePreview(file) {
        console.log("handlePreview",file);
        let fileUrl = process.env.VUE_APP_BASE_URL + '/member/readflie.jspx?filePath=' + file.response.data;
        if (!fileUrl.endsWith('.pdf')) {
          this.dialogImageUrl = fileUrl;
          this.dialogImageVisible = true;
        } else {
          this.dialogPdfUrl = fileUrl;
          window.open(fileUrl);
        }
      },
      handleExceed(files, fileList) {
        this.$message.error(`当前限制上传 1 个文件`);
      },
      beforeFileUpload(file) {
        const supportFileType = ["pdf"];
        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 200;

        if (!isSupport) {
          this.$message.error('只能上传['+supportFileType+']格式的文件!');
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 200MB!');
        }
        return isSupport && isLt100M;
      },
      digit: function(num, length){
        var str = '';
        num = String(num);
        length = length || 2;
        for(var i = num.length; i < length; i++){
          str += '0';
        }
        return num < Math.pow(10, length) ? str + (num|0) : num;
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      }
    }
  }
</script>
<style>
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }
  .el-transfer-div .transfer-footer {
    margin-left: 20px;
    padding: 6px 5px;
  }
  .el-transfer-div .el-transfer-panel{
    width: 530px;
  }
  .el-transfer-div .el-transfer__buttons {
    display: inline-grid;
    padding: 0;
  }
  .el-transfer-div .el-transfer__buttons .el-transfer__button {
    margin-left: 0;
    padding: 10px 12px;
  }
  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }
  .expiry ::placeholder {
    color: #F56C6C !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Member/BiddingOnline.vue